import { useMapStoreStateToClientState } from '@/hooks/useMapStoreStateToClientState';
import type { Store } from '@/stores';

export default function useStateOfEssentials(store: Store) {
  return useMapStoreStateToClientState(store, (store: Store) => ({
    currency: store.appStore.currency.currentCurrency,
  }));
}
